export const createInvalidAccessError = () => new DOMException('', 'InvalidAccessError');
//# sourceMappingURL=invalid-access-error.js.map